import {Type} from "class-transformer";
import {serializeType} from "./common";
import {FundingType} from "@app/shared/enums/funding-type.enum";
import {ItemType} from "@app/shared/enums/item-type.enum";
import {ItemApprovalType} from "@app/shared/enums/item-approval-type.enum";
import {ChargeCodeType} from "@app/shared";

export class ItemAdjustment {
  id: number;
  version: number;
  comments: string;
  quantityCounted: number;
  quantityDifference: number;
  inventoryDate: string;
  itemId: number;
  inventorySequence: number;
}

export class ItemLocator {
  id: number;
  version: number;
  floor: number;
  aisle: string;
  rack: string;
  shelf: string;
  locationName?: string;
  abstractItemId: number;
  orgAddressId: number;
}

export class PurchaseAccountMappings {
  id: number;
  version: number;
  mappingType: string;
  accountMappingType: string;
  accountGroupId: number;
  ledgerAccountId: number;
  abstractItemId: number;
  abstractItemNameOrNumber: string;
  ledgerAccountName: string;
  ledgerAccountNumber: number;
}

export class AbstractItem {
  id: number;
  version: number;
  subtype: ItemType;
  isIndirect: boolean = false;
  codeType: ChargeCodeType;
  fundingType?: FundingType;

  active: boolean;
  effectiveFrom?: string;             // for service items
  effectiveThru?: string;             // for service items
  approvalType: ItemApprovalType;
  isTaxable: boolean;
  nameOrNumber: string;
  manufacturerNumber: string;
  purchaseTxnDescription: string;
  salesTxnDescription: string;
  itemNotes: string;
  buyerNotes: string;
  quantityOnHand: number;
  unitCost: number;
  salesPrice: number;
  averageCost: number;
  totalValue: number;
  minReorderPoint: number;
  maxReorderPoint: number;
  catalogId: number;
  unitOfMeasureId: number;
  assetAccountId: number;
  incomeAccountId: number;
  operationalExpenseAccountId?: number;
  unallowableAccountId?: number;
  cogsAccountId: number;
  preferredVendorId: number;
  commodityCodeId: number;
  commodityCodeDescription: string;
  unitOfMeasureDescription: string;
  preferredVendorName: string;
  orgAddressId?: number;
  vendorLaborCategoryId?: number;
  @Type(serializeType(ItemAdjustment)) newAdjustment: ItemAdjustment;
  @Type(serializeType(ItemLocator)) itemLocators: ItemLocator[] = [];
  @Type(serializeType(PurchaseAccountMappings)) purchaseAccountMappings: PurchaseAccountMappings[];

  physicalCount?: number;
  delta?: number;
  adjustmentDescription: string;
  locationName?: string;
  catalogName?: string;
  projectName?: string;                         // vendor labor category associated project
  projectLaborCategoryPositionTitle?: string;   // project labor category associated with the vendor labor category
}

export class ItemCatalog {
  id: number;
  version: number;
  orgId: number;
  parentId: number;
  parentName?: string;
  adminId: number;
  adminName: string;
  name: string;
  accessType?: string;
  description: string;
  itemCount: number;
  @Type(serializeType(Date)) lastPhysicalInventory: Date;
  @Type(serializeType(ItemCatalog)) children: ItemCatalog[] = [];
}

export class ItemSearchParam {
  subtype: string;
  nameOrNumber: string;
  approvalType: string;
  location: number;
  days: number;
}


export class TableFooterSummary {
  subTotal: number;
  shipping: number;
  discountPercent: number;
  regularDiscountAmount: number;     //to be used in PR, SO, VendorInvoice
  expenseDiscountAmount: number;     // to be use in Customer Invoice
  laborDiscountAmount: number;       // to be use in Customer Invoice
  feeDiscountAmount: number;       // to be use in Customer Invoice
  taxes: number;
  laborTaxes: number;
  expenseTaxes: number;
  total: number;

  constructor() {
    // jC: do not initialize so that it means certain amount is not available e.g. shipping = null, means there is no shipping item

    // this.shipping = 0;
    // this.total = 0;
    // this.subTotal = 0;
    // this.discountPercent = 0;
    // this.regularDiscountAmount = 0;
    // this.expenseDiscountAmount = 0;
    // this.laborDiscountAmount = 0;
    // this.taxes = 0;
  }
}